module.exports = __webpack_public_path__ + "media/app/images/codepen-3c1386666097d5022b90219a7d9871b3.png";